import { TipoPersona } from "@shared/enums/TipoPersona";

export class ClienteEncabezado{
    id: string;
    razonSocial: string;
    numeroDocumento: string;
    tipoDocumento: number;
    condicionPrecio: number;
    ctaSap: string;
    enNuevo: boolean;
    esTrader: boolean;
    permiteRanchos: boolean;
    percepcionIVADif: number;
    activo?: boolean;
    fechaPercepcionIVADif: string;
    clienteObservado: boolean;
    tipoPersona: TipoPersona;
    cta_SGC:string;
}
